export const NEXT_OR_CURRENT_SLP_REQUEST = "NEXT_OR_CURRENT_SLP_REQUEST";
export const NEXT_OR_CURRENT_SLP_SUCCESS = "NEXT_OR_CURRENT_SLP_SUCCESS";
export const NEXT_OR_CURRENT_SLP_FAILURE = "NEXT_OR_CURRENT_SLP_FAILURE";

export const DEFER_SLP_REQUEST = "DEFER_SLP_REQUEST";
export const DEFER_SLP_SUCCESS = "DEFER_SLP_SUCCESS";
export const DEFER_SLP_FAILURE = "DEFER_SLP_FAILURE";

export const ALLOCATE_PLA_REQUEST = "ALLOCATE_PLA_REQUEST";
export const ALLOCATE_PLA_SUCCESS = "ALLOCATE_PLA_SUCCESS";
export const ALLOCATE_PLA_FAILURE = "ALLOCATE_PLA_FAILURE";

export const GET_CONTACT_NOTE_REQUEST = "GET_CONTACT_NOTE_REQUEST";
export const GET_CONTACT_NOTE_SUCCESS = "GET_CONTACT_NOTE_SUCCESS";
export const GET_CONTACT_NOTE_FAILURE = "GET_CONTACT_NOTE_FAILURE";

export const GET_AUDIT_TRAIL_LIST_REQUEST = "GET_AUDIT_TRAIL_LIST_REQUEST";
export const GET_AUDIT_TRAIL_LIST_SUCCESS = "GET_AUDIT_TRAIL_LIST_SUCCESS";
export const GET_AUDIT_TRAIL_LIST_FAILURE = "GET_AUDIT_TRAIL_LIST_FAILURE";

export const DELETE_COMPLETED_SLP_REQUEST = "DELETE_COMPLETED_SLP_REQUEST";
export const DELETE_COMPLETED_SLP_SUCCESS = "DELETE_COMPLETED_SLP_SUCCESS";
export const DELETE_COMPLETED_SLP_FAILURE = "DELETE_COMPLETED_SLP_FAILURE";

export const GET_COMPLETED_SLP_DETAILS_REQUEST =
  "GET_COMPLETED_SLP_DETAILS_REQUEST";
export const GET_COMPLETED_SLP_DETAILS_SUCCESS =
  "GET_COMPLETED_SLP_DETAILS_SUCCESS";
export const GET_COMPLETED_SLP_DETAILS_FAILURE =
  "GET_COMPLETED_SLP_DETAILS_FAILURE";

export const GET_ALL_SLP_GOALS_AND_ASSESSMENT_REQUEST =
  "GET_ALL_SLP_GOALS_AND_ASSESSMENT_REQUEST";
export const GET_ALL_SLP_GOALS_AND_ASSESSMENT_SUCCESS =
  "GET_ALL_SLP_GOALS_AND_ASSESSMENT_SUCCESS";
export const GET_ALL_SLP_GOALS_AND_ASSESSMENT_FAILURE =
  "GET_ALL_SLP_GOALS_AND_ASSESSMENT_FAILURE";

export const UPDATE_CONTACT_DATE_REQUEST = "UPDATE_CONTACT_DATE_REQUEST";
export const UPDATE_CONTACT_DATE_SUCCESS = "UPDATE_CONTACT_DATE_SUCCESS";
export const UPDATE_CONTACT_DATE_FAILURE = "UPDATE_CONTACT_DATE_FAILURE";
